module.exports = __webpack_public_path__ + "img/video-19.b79aaabe.png";